export default defineNuxtPlugin({
  name: 'zt:load-opening-hours',
  dependsOn: ['nuxt-easy-texts', 'zt:init-data'],
  async setup() {
    const { load } = useOpeningHours()
    await load()

    // @TODO: Update time and reload opening hours.
  },
})
